import { defineMessages } from 'react-intl'

const scope = `procurify.spending-cards.view.CardPinModal`

export default defineMessages({
  modalHeaderText: {
    id: `${scope}.modalHeaderText`,
    defaultMessage: 'Card PIN',
  },
  iframeLabel: {
    id: `${scope}.iframeLabel`,
    defaultMessage: 'Card PIN',
  },
  descriptionText1: {
    id: `${scope}.descriptionText1`,
    defaultMessage: 'The PIN for this card is:',
  },
  descriptionText2: {
    id: `${scope}.descriptionText2`,
    defaultMessage:
      "If you forget it, just come back here. And remember - don't share it with anyone.",
  },
})
